import type { NeighborhoodStoryDefInput } from '../schemas/neighborhood';

const item = (itemId: `fur_${string}` | `dec_${string}`) => ({ type: 'item', itemId, qty: 1 }) as const;

export const NEIGHBORHOOD_STORIES = [
  {
    id: 'lam',
    titleKey: 'neighborhood.lam.title',
    speakerKey: 'neighborhood.lam.speaker',
    setId: 'set_tea',
    inviteLetterId: 'ltr_neighborhood_lam',
    supplies: [
      { itemId: 'prod_milk_tea', qty: 2 },
      { itemId: 'prod_cookie_box', qty: 1 },
    ],
    decorationCount: 3,
    customerCount: 3,
    keepsakeItemId: 'fur_tea_cabinet',
    steps: [
      {
        titleKey: 'neighborhood.lam.0.title',
        bodyKey: 'neighborhood.lam.0.body',
        endingKey: 'neighborhood.lam.0.ending',
        rewards: [item('dec_tea_set'), item('fur_tea_table'), item('fur_tea_chair')],
      },
      {
        titleKey: 'neighborhood.lam.1.title',
        bodyKey: 'neighborhood.lam.1.body',
        endingKey: 'neighborhood.lam.1.ending',
        rewards: [{ type: 'coins', amount: 60 }, item('dec_tea_lantern')],
      },
      {
        titleKey: 'neighborhood.lam.2.title',
        bodyKey: 'neighborhood.lam.2.body',
        endingKey: 'neighborhood.lam.2.ending',
        rewards: [item('dec_tea_vase')],
      },
      {
        titleKey: 'neighborhood.lam.3.title',
        bodyKey: 'neighborhood.lam.3.body',
        endingKey: 'neighborhood.lam.3.ending',
        rewards: [item('fur_tea_cabinet')],
      },
    ],
  },
  {
    id: 'elias',
    titleKey: 'neighborhood.elias.title',
    speakerKey: 'neighborhood.elias.speaker',
    setId: 'set_old_europe',
    inviteLetterId: 'ltr_neighborhood_elias',
    requiresStory: 'lam',
    supplies: [
      { itemId: 'prod_canned_coffee', qty: 2 },
      { itemId: 'prod_cookie_box', qty: 2 },
    ],
    decorationCount: 3,
    customerCount: 3,
    keepsakeItemId: 'fur_europe_keepsake_chair',
    steps: [
      {
        titleKey: 'neighborhood.elias.0.title',
        bodyKey: 'neighborhood.elias.0.body',
        endingKey: 'neighborhood.elias.0.ending',
        rewards: [item('fur_europe_table'), item('fur_europe_chair'), item('dec_europe_candles')],
      },
      {
        titleKey: 'neighborhood.elias.1.title',
        bodyKey: 'neighborhood.elias.1.body',
        endingKey: 'neighborhood.elias.1.ending',
        rewards: [{ type: 'coins', amount: 70 }, item('dec_europe_books')],
      },
      {
        titleKey: 'neighborhood.elias.2.title',
        bodyKey: 'neighborhood.elias.2.body',
        endingKey: 'neighborhood.elias.2.ending',
        rewards: [item('dec_europe_vase')],
      },
      {
        titleKey: 'neighborhood.elias.3.title',
        bodyKey: 'neighborhood.elias.3.body',
        endingKey: 'neighborhood.elias.3.ending',
        rewards: [item('fur_europe_keepsake_chair')],
      },
    ],
  },
] as const satisfies readonly NeighborhoodStoryDefInput[];
